/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tts_Tool_Format_LabelInputs */

const en_tts_tool_format_label = /** @type {(inputs: Tts_Tool_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format`)
};

const es_tts_tool_format_label = /** @type {(inputs: Tts_Tool_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato`)
};

/**
* | output |
* | --- |
* | "Format" |
*
* @param {Tts_Tool_Format_LabelInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const tts_tool_format_label = /** @type {((inputs?: Tts_Tool_Format_LabelInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tts_Tool_Format_LabelInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tts_tool_format_label(inputs)
	return en_tts_tool_format_label(inputs)
});